import WarehouseActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperWarehouse:null,
  errorInternal:false
};

function WarehouseReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case WarehouseActions.RESET_LIST:
      return INITIAL_STATE;
    case WarehouseActions.NEW_DATA:
      return { ...state,  errorInternal:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case WarehouseActions.UPDATE_DATA:
      return { ...state, errorInternal:false, isProcessing: false, single:null, isNewRecord:false};
    case WarehouseActions.VIEW_DATA:
      return { ...state, errorInternal:false, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case WarehouseActions.RESET_DATA:
      return { ...state, errorInternal:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case WarehouseActions.DELETE_DATA:
      return { ...state, errorInternal:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case WarehouseActions.ON_SUBMIT:
      return { ...state, errorInternal:false, onSubmit:true};
    case WarehouseActions.SHOW_DATA:
      return { ...state,  errorInternal:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case WarehouseActions.SUCCESS_DATA:
      return { ...state, errorInternal:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case WarehouseActions.PROCESS_DATA:
      return { ...state, errorInternal:false, isProcessing: true, isError: false,isSuccess:false};
    case WarehouseActions.ERROR_DATA:
      return { ...state,  errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case WarehouseActions.GET_HELPER_WAREHOUSE:
      return { ...state, errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperWarehouse:action.payload};
    case WarehouseActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
      
    default:
      return state;
    }
}

export default WarehouseReducer;